/**
 * Settings Page
 * Main page for account settings management
 */

import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../../../stores/auth-store';
import {
  SettingsHero,
  SubscriptionCard,
  ProfileCard,
  LanguageCard,
  SecurityCard,
  DangerZoneCard,
} from './components';

export default function Settings() {
  const { isLoading } = useAuthStore();

  // Show loading state while auth is initializing
  if (isLoading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <Loader2 className="w-8 h-8 animate-spin text-primary-600" />
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section */}
      <SettingsHero />

      {/* Main Content */}
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-8 pb-16 relative z-10">
        {/* Cards Grid */}
        <div className="space-y-6">
          {/* Subscription */}
          <div className="animate-fade-in">
            <SubscriptionCard />
          </div>

          {/* Profile Information */}
          <div className="animate-fade-in animation-delay-100">
            <ProfileCard />
          </div>

          {/* Language */}
          <div className="animate-fade-in animation-delay-100">
            <LanguageCard />
          </div>

          {/* Security */}
          <div className="animate-fade-in animation-delay-200">
            <SecurityCard />
          </div>

          {/* Danger Zone */}
          <div className="animate-fade-in animation-delay-200">
            <DangerZoneCard />
          </div>
        </div>
      </div>
    </div>
  );
}
